export default "__VITE_ASSET__D1m8ZUAU__"